import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        loading: '='
    },
    template: `
        <div class="block08" ng-class="{'skeleton': vm.loading }">
            <div class="colholder">
                <div class="col col01 fixed">
                    <div class="heading01"><h2>{{ 'report.Device statistic' | translate }}</h2></div>
                    <table class="data03">
                        <thead>
                        <tr>
                            <th>{{ 'report.Device' | translate }}</th>
                            <th>{{ 'report.Visits' | translate }}</th>
                            <th>{{ 'report.Percentage' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr ng-if="vm.loading" ng-repeat="n in [].constructor(4) track by $index">
                            <td><div class="skeleton-cell"></div></td>
                            <td><div class="skeleton-cell"></div></td>
                            <td><div class="skeleton-cell"></div></td>
                        </tr>
                        <tr ng-if="!vm.loading" ng-repeat="device in vm.list.items">
                            <td>{{ vm.getDeviceNameTranslation(device.name) }}</td>
                            <td>{{ device.visits }}</td>
                            <td>{{ device.percentage }}%</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col col01 fixed">
                    <!-- If there are no items, display a message -->
                    <div ng-if="!vm.loading && !vm.list.items.length" class="no-data-message">
                        <p>{{ 'search.No results' | translate }}</p>
                    </div>
                    <!-- Canvas for chart, only if there are items -->
                    <canvas id="myChart" ng-if="!vm.loading && vm.list.items.length"></canvas>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, $scope, $timeout, $translate) {
        this.lodash = lodash;
        this.$scope = $scope;
        this.chart = null;
        this.$timeout = $timeout;
        this.$translate = $translate;
    }

    $onInit () {
        this.$scope.$watch(() => this.loading, (newValue) => {
            if (newValue === false) {
                this.$timeout(() => {
                    this.initializeChart();
                }, 100);
            }
        });
    }

    getDeviceNameTranslation (name) {
        return this.$translate.instant(`report.${name}`);
    }

    initializeChart () {
        const ctx = document.getElementById('myChart');
        if (ctx && this.list.items) {
            const labels = [];
            const data = [];
            this.lodash.forEach(this.list.items, (device) => {
                labels.push(this.getDeviceNameTranslation(device.name));
                data.push(device.percentage);
            });
            this.chart = new Chart(ctx, { // eslint-disable-line
                type: 'doughnut',
                data: {
                    labels,
                    datasets: [{
                        label: '%',
                        data,
                        borderWidth: 1,
                        backgroundColor: ['#261c69', '#5344d1', '#ff5a5b', '#ffa19e'], // Colors
                        borderColor: '#ffffff', // Optional: white border for better visibility
                        hoverOffset: 8 // Optional: slight hover effect
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false, // Allow resizing
                    cutout: '85%', // Adjust doughnut hole size (0% = pie chart, 50% = default)
                    plugins: {
                        legend: {
                            position: 'bottom' // Move legend if needed
                        },
                        tooltip: {
                            callbacks: {
                                label: function (tooltipItem) { // eslint-disable-line
                                    const value = tooltipItem.raw || 0;
                                    return ` ${value}%`; // Format: "Desktop: 100%"
                                }
                            }
                        }
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/overview/devicestatistics/index.js